"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _PatientProfileInfo = _interopRequireDefault(require("./PatientProfileInfo"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _PatientProfileInfo.default;
exports.default = _default;